import $ from 'jquery';
// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------
$(document).ready(function() {
  // Dev Code
});
